import { Controller } from "@hotwired/stimulus"
import L from "leaflet"
import { MapConfig } from "./map/map_config.js"
import { MapRenderer } from "./map/map_renderer.js"

// Draws a recorded hunt track: polyline plus start (green) and end (red) markers, framed to fit.
export default class extends Controller {
  static targets = ["container"]
  static values = { points: Array, marker: String } // [[lat, lng], ...]

  connect() {
    // Modal content is laid out after connect, so wait before sizing the map
    this.timeout = setTimeout(() => this.draw(), 300)
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.map?.remove()
  }

  draw() {
    const points = this.pointsValue
    if (!points.length) return

    const osm = MapConfig.getOSMTileLayerOptions()
    this.map = L.map(this.containerTarget)
    L.tileLayer(osm.url, osm.options).addTo(this.map)

    const line = L.polyline(points, { color: "#e8590c", weight: 4 }).addTo(this.map)
    const dot = (latlng, color) =>
      L.circleMarker(latlng, { radius: 7, color: "#fff", weight: 2, fillColor: color, fillOpacity: 1 }).addTo(this.map)
    dot(points[0], "#2f9e44")
    if (points.length > 1) dot(points[points.length - 1], "#d63939")

    // Saved geolocation marker shares the map with the route
    const marker = this.markerValue && JSON.parse(this.markerValue)
    if (marker?.length) new MapRenderer(this.map).renderPreviewLocation(marker)

    this.map.fitBounds(line.getBounds(), { padding: [20, 20], maxZoom: 17 })
    this.map.invalidateSize()
  }
}
